module.exports = __webpack_public_path__ + "static/media/shipSize-letter.da40ff95.svg";